var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "m5.918 16.383-2.151 1.173M5.109 12.846l-2.442-.078M4.064 8.053 6.14 9.368M8.748 6.884l-1.152-2.19M12.223 6.059l.075-2.488M15.638 7.108l1.291-2.114M20.23 8.589l-2.15 1.173M21.333 13.376l-2.441-.078M17.86 16.776l2.076 1.315M10.03 18.45c0-1.871-.53-2.105-1.467-3.714A4.111 4.111 0 0 1 8 12.656c0-2.25 1.79-4.072 4-4.072s4 1.823 4 4.072c0 .758-.206 1.469-.563 2.08-.74 1.265-1.224 1.075-1.398 2.525-.046.39-.07.787-.07 1.189v.5c0 .778-.625 1.414-1.39 1.414h-1.162c-.765 0-1.389-.636-1.389-1.413v-.501h.002ZM13.322 20.582c0 .744-.591 1.346-1.322 1.346-.73 0-1.321-.602-1.321-1.346",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.2cb4be3e.svg";
export { ForwardRef as ReactComponent };